import VerificationInputComponent from 'react-verification-input';

export const VerificationInput =
  // `react-verification-input` is CJS (`exports.default` + `__esModule`). Under
  // Vite 8 / Rolldown the default import can resolve to the module namespace
  // object instead of the component, so fall back to `.default` when present.
  (
    VerificationInputComponent as {
      default?: typeof VerificationInputComponent;
    }
  ).default ?? VerificationInputComponent;
